/**
 * 🏗 Returns a y-axis line that will show when the user interacts with the chart
 * @param lineColor - string 
 * @returns 
 */
export function yAxisInteractionLine(vuetify: any, lineColor ?: string): any {
  return {
    id: "tooltipLine",
    afterDraw: (chart: any) => {
      if (chart.tooltip?._active?.length) {
        let x = chart.tooltip._active[0].element.x;
        let yAxis = chart.scales.y;
        let ctx = chart.ctx;
        ctx.save();
        ctx.beginPath();
        ctx.moveTo(x, yAxis.top);
        ctx.lineTo(x, yAxis.bottom);
        ctx.lineWidth = 1;
        ctx.strokeStyle = lineColor
          ? lineColor
          : (vuetify.theme.currentTheme.primary as string);
        ctx.stroke();
        ctx.restore();
      }
    },
  };
}